module.exports = __webpack_public_path__ + "fonts/Sanchez-Regular_dot.otf";